import {computed} from 'vue';

/**
 * useMarketingCta — auth-aware CTAs for the marketing & sport landing pages.
 * A logged-in visitor is sent straight to create a club (and the "create
 * account" wording becomes "create your club") instead of being asked to
 * register. Guests get the normal sign-up funnel.
 */
export function useMarketingCta() {
  const {isAuthenticated} = useAuthService();

  // Where the primary "get started / set it up / start a ..." buttons point.
  const getStartedTo = computed(() => (isAuthenticated.value ? {name: 'ClubCreate'} : '/register'));

  // Label for the big final-CTA button.
  const accountCtaLabel = computed(() => (isAuthenticated.value ? 'Create your club' : 'Create your free account'));

  return {isAuthenticated, getStartedTo, accountCtaLabel};
}
